enum WorkspaceApiKeyStatus {
  active = 'active',
  inactive = 'inactive',
  suspended = 'suspended',
}

export default WorkspaceApiKeyStatus
